module.exports = __webpack_public_path__ + "img/podium_img01.3851cdb7.png";